import { Button } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import logo from '~/logo.svg';
import type { AppState } from '~/store/reducers';
import '~/pages/home/Home.css';

const LoginButton = () => {
  return (
    <Button variant="contained" color="primary" href="/auth/login">
      Go to Login
    </Button>
  );
};

function Home() {
  const count = useSelector((state: AppState) => state.counter.value);
  const dispatch = useDispatch();
  return (
    <div className="Home">
      <header className="Home-header">
        <img src={logo} className="Home-logo" alt="logo" />
        <a
          className="Home-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>{' '}
        <Button
          onClick={() => dispatch({ type: 'counter/increment' })}
          variant="contained"
        >
          Hello World - {count}
        </Button>
        ;
        <LoginButton />
      </header>
    </div>
  );
}

export default Home;
